const axios = require('axios').default;

let form = document.getElementById("newsletter-footer");

let formSubmit = form.getElementsByClassName("footer__submit");
let formSuccess = form.getElementsByClassName("form__success");
let formError = form.getElementsByClassName("form__error");
let formFields = form.getElementsByClassName("input--small");

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

function looseFocus() {
	let el = document.querySelector( ':focus' );
	if( el ) el.blur();
}

function setFormSuccess() {
	formSubmit[0].classList.add("footer__submit--fade");
	formSuccess[0].classList.add("form__msg--visible");
	for (let item of formFields) { item.classList.add("footer-input--fade") }
	looseFocus();
}

function setFormError() {
	formSubmit[0].classList.add("footer__submit--fade");
	formError[0].classList.add("form__msg--visible");
	for (let item of formFields) {item.classList.add("footer-input--fade") }
	looseFocus();
}

// add all eventlisteners for buttons etc.
export function addListenersFormFooter() {
	form.addEventListener("submit", function (e) {
		
		// prevent default post method by statamic
		e.preventDefault();

		// submit data
		axios.post(form.action, new FormData(form))
		.then(response => {
			setFormSuccess();
		})
		.catch(error => {
			setFormError();
		})
	});
}